import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AddressQualityEnum} from "../../types/address-quality.enum";

export class AddressQualitiesDisplayListComponent implements IController {
  addressQualities: AddressQualityEnum[];
  isRow: boolean;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onRemove(addressQuality: AddressQualityEnum) {
    this.onChange({
      addressQualities: _.filter(this.addressQualities, (aq: string) => {
        return aq !== addressQuality
      })
    });
  }


}

angular
  .module('bringoz.admin.addresses')
  .component('addressQualitiesDisplayList', {
    bindings: {
      addressQualities: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./address-qualities-display-list.html').default,
    controller: AddressQualitiesDisplayListComponent
  });
